export const janinaMalkowska = {
    'mydrId': 'janinamałkowska',
    'firstName': 'Janina',
    'lastName': 'Małkowska',
    'profession': 'Psychiatra dzieci i młodzieży',
    'avatar': 'janina-malkowska.webp',
    'slug': 'psychiatra-dzieci-i-mlodziezy-janina-malkowska',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychiatry', 'children']
    ]
}